import { IObservable, Subject } from '~/rage/utils';
import { ICallHistoryEntry, IPhoneCallState, PhoneCallStatus } from '~/shared';
import { IPhoneCallsService } from './phoneCallsServiceTypes';

const mockCallHistory: ICallHistoryEntry[] = [
	{
		contactNumber: '5550101',
		timestamp: Date.now() - 3600000,
		status: 'completed',
		duration: 120,
	},
	{
		contactNumber: '5550000',
		timestamp: Date.now() - 7200000,
		status: 'missed',
	},
];

export class PhoneCallsServiceStub implements IPhoneCallsService {
	private callState = new Subject<IPhoneCallState | null>(null);
	private callHistory = new Subject<ICallHistoryEntry[]>(mockCallHistory);
	private currentCallState: IPhoneCallState | null = null;

	constructor() {
		(global as any).simulateIncomingCall = (
			number: string,
			name?: string,
		): void => {
			const callState: IPhoneCallState = {
				status: PhoneCallStatus.INCOMING,
				contactNumber: number,
				contactName: name ?? 'Dmitrii Stepanov',
			};

			this.currentCallState = callState;
			this.callState.next(callState);
		};
	}

	public getCallState(): IObservable<IPhoneCallState | null> {
		return this.callState;
	}

	public async call(number: string): Promise<void> {
		console.log('phoneCalls: call', number);

		const callState: IPhoneCallState = {
			status: PhoneCallStatus.DIALING,
			contactNumber: number,
			contactName: 'Dmitrii Stepanov',
		};

		this.currentCallState = callState;
		this.callState.next(callState);

		setTimeout(() => {
			this.currentCallState = {
				...callState,
				status: PhoneCallStatus.CONNECTED,
				startTime: Date.now(),
			};
			this.callState.next(this.currentCallState);
		}, 3000);
	}

	public async answerCall(): Promise<void> {
		console.log('phoneCalls: answerCall');
		if (this.currentCallState) {
			this.currentCallState = {
				...this.currentCallState,
				status: PhoneCallStatus.CONNECTED,
				startTime: Date.now(),
			};
			this.callState.next(this.currentCallState);
		}
	}

	public async rejectCall(): Promise<void> {
		console.log('phoneCalls: rejectCall');
		if (this.currentCallState) {
			this.currentCallState = {
				...this.currentCallState,
				status: PhoneCallStatus.ENDED,
			};
			this.callState.next(this.currentCallState);
		}
		setTimeout(() => {
			this.currentCallState = null;
			this.callState.next(null);
		}, 1000);
	}

	public async endCall(): Promise<void> {
		console.log('phoneCalls: endCall');
		if (this.currentCallState) {
			this.currentCallState = {
				...this.currentCallState,
				status: PhoneCallStatus.ENDED,
			};
			this.callState.next(this.currentCallState);
		}
		setTimeout(() => {
			this.currentCallState = null;
			this.callState.next(null);
		}, 1000);
	}

	public getCallHistory(): IObservable<ICallHistoryEntry[]> {
		return this.callHistory;
	}
}
